import type { IconData } from '@stacksjs/iconify-core'

export const iceCream2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M17.009 3.132c-4.409.184-7.641 3.339-7.845 7.746A177 177 0 0 0 9 19c0 3.359.067 6.023.164 8.122c.204 4.407 3.436 7.562 7.845 7.746c1.88.079 4.188.132 6.99.132c2.804 0 5.113-.053 6.992-.132c4.409-.184 7.641-3.338 7.845-7.746c.097-2.098.164-4.763.164-8.122s-.067-6.024-.164-8.122C38.632 6.47 35.4 3.316 30.99 3.132A167 167 0 0 0 24 3a168 168 0 0 0-6.991.132\"/><path d=\"m19.205 34.941l-.612 4.58c-.337 2.528 1.276 4.96 3.799 5.33c.613.09 1.179.149 1.608.149s.996-.06 1.609-.15c2.523-.37 4.136-2.801 3.798-5.329l-.611-4.58M19 13v12m10-12v12\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default iceCream2
